module.exports = __webpack_public_path__ + "img/error.86c8afe6.svg";